export default __webpack_public_path__ + "static/media/LoadingWOLFmini.12fa1510.gif";